<div class="wre-table-container w-100">
  <div
    #tableContainer
    class="table-responsive"
    (scroll)="offset = tableContainer.scrollLeft + 'px'">
    <table class="table wre-table fixed-column table-hover p-0 m-0">
      <thead class="text-center p-0 m-0" [style.left]="'-' + offset">
        <tr class="t-header">
          <th class="text-nowrap col-ellipsis column-active"></th>
          @if (fieldType === 'Reviewer') {
            <th class="text-nowrap col-ellipsis column-active"></th>
          }
          <th class="text-nowrap col-ellipsis column-users">
            {{ fieldType == 'Reviewer' ? 'Name' : 'Field Value' }}
          </th>
          <th class="text-nowrap col-ellipsis column-adgroups">Status</th>
        </tr>
      </thead>

      <tbody class="p-0 m-0">
        @for (item of list; track item; let isLast = $last) {
          <tr class="tr-padding" [ngClass]="{ 'border-bottom': isLast }">
            @if (item.isAdded || item.isDeleted || item.isUpdated) {
              <td class="text-nowrap col-ellipsis column-active">
                <i
                  class="far"
                  [ngClass]="{
                    'fa-plus': item.isAdded,
                    'fa-exchange': item.isUpdated,
                    'fa-minus': item.isDeleted,
                  }"></i>
              </td>
            }
            @if (fieldType === 'Reviewer') {
              <td class="text-nowrap col-ellipsis column-active">
                <i class="far" ngClass="fa-user"></i>
              </td>
            }
            <td class="text-nowrap col-ellipsis column-users">
              @if (item.value) {
                <span>{{ item.value }}</span>
              }
            </td>
            <td class="text-nowrap col-ellipsis column-adgroups">
              @if (item.status) {
                <span>Active</span>
              }
              @if (!item.status) {
                <span>Inactive</span>
              }
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
</div>
